// Environment lookup that is safe in browser bundles, where `process` is
// not defined. Server runtimes (Node, Bun) read process.env as before.

export function readEnv(name: string): string | undefined {
  return typeof process === 'undefined' ? undefined : process.env[name];
}
